interface ValidationData {
  brandValidationList?: any[];
  competitorValidationList?: any[];
  filterValidationList?: any[];
  marketValidationList?: any[];
  segmentValidationList?: any[];
}

export function getFormattedValidationState(data: ValidationData) {
  const result: any = {};
  if (data?.brandValidationList) {
    const updatedBrands = data?.brandValidationList
      .filter((item) => item?.brandName && !item?.isValid)
      .map((item) => item?.brandName);
    if (updatedBrands?.length > 0) {
      result.brand = updatedBrands;
    }
  }
  if (data?.competitorValidationList) {
    const updatedCompetitors = data?.competitorValidationList
      .filter((item) => item?.brandName && !item?.isValid)
      .map((item) => item?.brandName);
    if (updatedCompetitors?.length > 0) {
      result.competitor = updatedCompetitors;
    }
  }
  // if (data?.filterValidationList) {
  //   const updatedFilters = data?.filterValidationList
  //     .filter((item) => item?.filterName)
  //     .map((item) => item?.filterName);
  //   if (updatedFilters?.length > 0) {
  //     result.filter = updatedFilters;
  //   }
  //   data?.filterValidationList?.forEach((item) => {
  //     const filterResult = item?.filterOptions?.map((ele: any) => {
  //       return `${ele?.filterOptionName}/${item.filterName}`;
  //     });
  //     if (result?.filter) {
  //       result.filter = [...result.filter, ...filterResult];
  //     } else {
  //       result.filter = [...filterResult];
  //     }
  //   });
  // }
  if (data?.marketValidationList) {
    const updatedMarkets = data?.marketValidationList
      .filter((item) => item?.marketName && !item?.isValid)
      .map((item) => item?.marketName);
    if (updatedMarkets?.length > 0) {
      result.market = updatedMarkets;
    }
  }
  // if (data?.segmentValidationList) {
  //   data?.segmentValidationList?.forEach(
  //     ({
  //       expiredFilters,
  //       detachedFilters,
  //       segmentId,
  //       segmentMarkets,
  //       filters,
  //     }: any) => {
  //       filters?.forEach((item: any) => {
  //         if (
  //           expiredFilters.includes(item.filterName) ||
  //           detachedFilters.includes(item.filterName)
  //         ) {
  //           const filterResult = item?.filterOptions?.map((ele: any) => {
  //             return `${ele?.filterOptionName}/${item.filterName}`;
  //           });
  //           if (result?.filter) {
  //             result.filter = [...result.filter, ...filterResult];
  //           } else {
  //             result.filter = [...filterResult];
  //           }
  //         }
  //       });
  //     }
  //   );
  // }
  return Object.keys(result)?.length > 0 ? result : null;
}
